import { Plus } from 'lucide-react';
import styles from './AddButton.module.css';

export default function AddButton({ label, onClick }) {
  return (
    <button type="button" className={styles.addBtn} onClick={onClick}>
      <Plus size={16} strokeWidth={1.5} />
      {label}
    </button>
  );
}
